export const GET_TOURNAMENTS = `
  query GetTournaments(
    $playerId: String!
    $operatorId: String!
    $brandId: String
    $currency: String
    $gameCode: String
    $tournamentStatus: String
    $size: Int
    $page: Int
  ) {
    players {
      getTournaments(
        playerId: $playerId
        operatorId: $operatorId
        brandId: $brandId
        currency: $currency
        gameCode: $gameCode
        tournamentStatus: $tournamentStatus
        size: $size
        page: $page
      ) {
        status
        success
        message
        code
        data {
          count
          tournaments {
            tournamentName
            tournamentId
            prize
            prizePool
            participates
            tournamentStartDate
            tournamentEndDate
            tournamentTimeFrom
            tournamentTimeTo
            tournamentType
            tournamentStatus
            isUserOptIn
            tournamentOptin
            rewardType
            totalRewardAmount
            tournamentDays
            slabs {
              game
              fromRank
              toRank
              freeSpinsCount
              freeSpinsValue
              rewardAmount
            }
          }
        }
      }
    }
  }
`

export const GET_TOURNAMENTS_HISTORY = `
  query GetTournamentsHistory(
    $playerId: String!
    $operatorId: String!
    $brandId: String
    $currency: String
    $gameCode: String
    $size: Int
    $page: Int
  ) {
    players {
      getTournamentsHistory(
        playerId: $playerId
        operatorId: $operatorId
        brandId: $brandId
        currency: $currency
        gameCode: $gameCode
        size: $size
        page: $page
      ) {
        status
        success
        message
        code
        data {
          count
          tournaments {
            tournamentName
            tournamentId
            endedDate
            rank
            won
            participates
            prizePool
            prize
            userOptinMessage
            tournamentType
            status
            rewardType
            totalRewardAmount
            tournamentDays
          }
        }
      }
    }
  }
`

export const GET_TOURNAMENT_ACTIVE_LEADERBOARD = `
  query GetTournamentActiveLeaderboard($tournamentId: String!, $size: Int, $page: Int) {
    players {
      getTournamentActiveLeaderboard(tournamentId: $tournamentId, size: $size, page: $page) {
        status
        success
        message
        code
        data {
          count
          leaderboard {
            playerId
            rank
            points
          }
        }
      }
    }
  }
`

export const GET_TOURNAMENT_LEADERBOARD_HISTORY = `
  query GetTournamentLeaderboardHistory($tournamentId: String!, $size: Int, $page: Int) {
    players {
      getTournamentLeaderboardHistory(tournamentId: $tournamentId, size: $size, page: $page) {
        status
        success
        message
        code
        data {
          count
          leaderboard {
            playerId
            position
            points
            freeBets
            rewardAmount
            rewardType
          }
        }
      }
    }
  }
`

export const GET_TOURNAMENT_PRIZES = `
  query GetTournamentPrizes($tournamentId: String!) {
    players {
      getTournamentPrizes(tournamentId: $tournamentId) {
        status
        success
        message
        code
        data {
          prizes {
            position
            rewardAmount
            rewardType
          }
        }
      }
    }
  }
`

export const TOURNAMENT_OPT_IN = `
  query TournamentOptIn($tournamentId: String!, $playerId: String!, $optInStatus: Boolean!) {
    players {
      tournamentOptIn(tournamentId: $tournamentId, playerId: $playerId, optInStatus: $optInStatus) {
        status
        success
        message
        code
        data {
          optIn {
            tournamentId
            optInStatus
            message
          }
        }
      }
    }
  }
`
